module.exports = __webpack_public_path__ + "f40feadde1bf93c6d7176e6e6b30675e.png";